import { Box } from '@mantine/core';
import React from 'react';

type SectionTitleProps = {
  title: string;
  index: number;
};

export const SectionTitle = ({ title, index }: SectionTitleProps) => {
  return (
    <Box className="relative flex flex-col justify-center">
      <h2 className="relative font-montserrat text-4xl font-bold uppercase tracking-[0.2rem] text-secondary-600 dark:text-lightBlue-200">
        {title}
      </h2>
      {/* <Box className="absolute flex items-center xxs:max-md:hidden md:-left-[80px] md:w-[40px] lg:-left-[200px] lg:w-[160px]">
        <p className="mr-[40px] text-5xl font-bold text-primary-500">
          0{index}
        </p>
        <hr className="w-full rounded-l-full rounded-r-full border-[1px] border-primary-500/80" />
      </Box> */}
    </Box>
  );
};
